import axios from 'axios'

export const $authUser = axios.create({
    headers: {
        Authorization: 'Bearer 4vD2Yw@EfYn=5JLbw=Yt6Fj7d'
    },
    baseURL: process.env.VUE_APP_ALERUS_API_URL
})

export const $axios = axios.create({
    baseURL: process.env.VUE_APP_APPSYNC_API_URL
})